import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "generate",
  "description": "turbo generate 명령어에 대한 API 레퍼런스"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "새로운 앱과 패키지로 Turborepo를 확장합니다."
  }, {
    "heading": "",
    "content": "turbo generate run [generator-name]: 저장소에 정의된 사용자 정의 생성기를 실행합니다."
  }, {
    "heading": "",
    "content": "turbo generate workspace [options]: 기존 패키지를 복사하거나 처음부터 새 패키지를 만듭니다."
  }, {
    "heading": "",
    "content": "사용자 정의 생성기 작성에 대한 자세한 정보와 실용적인 사용 사례는 \"코드 생성\" 가이드를 참조하세요."
  }, {
    "heading": "",
    "content": "turbo gen은 turbo generate의 별칭입니다. 또한 run이 기본 명령어이므로\nturbo gen은 turbo generate run과 동일합니다."
  }, {
    "heading": "run-generator-name",
    "content": "저장소에 정의된 사용자 정의 생성기를 실행합니다."
  }, {
    "heading": "--args",
    "content": "생성기의 프롬프트에 직접 전달할 답변입니다."
  }, {
    "heading": "--config-path",
    "content": "생성기 설정 파일입니다."
  }, {
    "heading": "--config-path",
    "content": "기본값: turbo/generators/config.js"
  }, {
    "heading": "--root-path",
    "content": "저장소의 루트입니다"
  }, {
    "heading": "--root-path",
    "content": "기본값: 루트 turbo.json이 있는 디렉토리"
  }, {
    "heading": "workspace",
    "content": "새 workspace를 생성합니다."
  }, {
    "heading": "--name-name",
    "content": "package.json의 name 키에 사용될 새 workspace의 이름입니다. name 키는 저장소에서 패키지의 고유 식별자입니다."
  }, {
    "heading": "--empty",
    "content": "빈 workspace를 생성합니다. 기본값은 true입니다."
  }, {
    "heading": "--copy-nameurl",
    "content": "monorepo 내의 로컬 workspace 이름 또는 모든 브랜치 및/또는 하위 디렉토리가 있는 정규화된 GitHub URL입니다."
  }, {
    "heading": "--destination-path",
    "content": "새 workspace가 생성될 위치입니다."
  }, {
    "heading": "--type-apppackage",
    "content": "생성할 workspace의 유형입니다 (app 또는 package)."
  }, {
    "heading": "--root-path-1",
    "content": "저장소의 루트입니다. 기본값은 루트 turbo.json의 디렉토리입니다."
  }, {
    "heading": "--show-all-dependencies",
    "content": "의존성을 추가할 때 workspace 유형별 의존성 필터링을 방지합니다."
  }, {
    "heading": "--example-path-path--p-path",
    "content": "드문 경우지만, GitHub URL에 슬래시가 있는 브랜치 이름(예: bug/fix-1)과 예제 경로(예: foo/bar)가 포함될 수 있습니다. 이 경우 예제 경로를 별도로 지정해야 합니다."
  }],
  "headings": [{
    "id": "run-generator-name",
    "content": "run [generator-name]"
  }, {
    "id": "플래그-옵션",
    "content": "플래그 옵션"
  }, {
    "id": "--args",
    "content": "--args"
  }, {
    "id": "--config-path",
    "content": "--config <path>"
  }, {
    "id": "--root-path",
    "content": "--root <path>"
  }, {
    "id": "workspace",
    "content": "workspace"
  }, {
    "id": "플래그-옵션-1",
    "content": "플래그 옵션"
  }, {
    "id": "--name-name",
    "content": "--name <name>"
  }, {
    "id": "--empty",
    "content": "--empty"
  }, {
    "id": "--copy-nameurl",
    "content": "--copy <name>/<url>"
  }, {
    "id": "--destination-path",
    "content": "--destination <path>"
  }, {
    "id": "--type-apppackage",
    "content": "--type <app/package>"
  }, {
    "id": "--root-path-1",
    "content": "--root <path>"
  }, {
    "id": "--show-all-dependencies",
    "content": "--show-all-dependencies"
  }, {
    "id": "--example-path-path--p-path",
    "content": "--example-path <path>, -p <path>"
  }]
};
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#run-generator-name",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "run [generator-name]"
    })
  })
}, {
  depth: 3,
  url: "#플래그-옵션",
  title: _jsx(_Fragment, {
    children: "플래그 옵션"
  })
}, {
  depth: 4,
  url: "#--args",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--args"
    })
  })
}, {
  depth: 4,
  url: "#--config-path",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--config <path>"
    })
  })
}, {
  depth: 4,
  url: "#--root-path",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--root <path>"
    })
  })
}, {
  depth: 2,
  url: "#workspace",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "workspace"
    })
  })
}, {
  depth: 3,
  url: "#플래그-옵션-1",
  title: _jsx(_Fragment, {
    children: "플래그 옵션"
  })
}, {
  depth: 4,
  url: "#--name-name",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--name <name>"
    })
  })
}, {
  depth: 4,
  url: "#--empty",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--empty"
    })
  })
}, {
  depth: 4,
  url: "#--copy-nameurl",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--copy <name>/<url>"
    })
  })
}, {
  depth: 4,
  url: "#--destination-path",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--destination <path>"
    })
  })
}, {
  depth: 4,
  url: "#--type-apppackage",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--type <app/package>"
    })
  })
}, {
  depth: 4,
  url: "#--root-path-1",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--root <path>"
    })
  })
}, {
  depth: 4,
  url: "#--show-all-dependencies",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--show-all-dependencies"
    })
  })
}, {
  depth: 4,
  url: "#--example-path-path--p-path",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--example-path <path>"
    }), ", ", _jsx("code", {
      children: "-p <path>"
    })]
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "새로운 앱과 패키지로 Turborepo를 확장합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " generate"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#run-generator-name",
          children: _jsx(_components.code, {
            children: "turbo generate run [generator-name]"
          })
        }), ": 저장소에 정의된 사용자 정의 생성기를 실행합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#workspace",
          children: _jsx(_components.code, {
            children: "turbo generate workspace [options]"
          })
        }), ": 기존 패키지를 복사하거나 처음부터 새 패키지를 만듭니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["사용자 정의 생성기 작성에 대한 자세한 정보와 실용적인 사용 사례는 ", _jsx(_components.a, {
        href: "/docs/guides/generating-code",
        children: "\"코드 생성\" 가이드"
      }), "를 참조하세요."]
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "turbo gen"
        }), "은 ", _jsx(_components.code, {
          children: "turbo generate"
        }), "의 별칭입니다. 또한 ", _jsx(_components.code, {
          children: "run"
        }), "이 기본 명령어이므로\n", _jsx(_components.code, {
          children: "turbo gen"
        }), "은 ", _jsx(_components.code, {
          children: "turbo generate run"
        }), "과 동일합니다."]
      })
    }), "\n", _jsx(_components.h2, {
      id: "run-generator-name",
      children: _jsx(_components.code, {
        children: "run [generator-name]"
      })
    }), "\n", _jsx(_components.p, {
      children: "저장소에 정의된 사용자 정의 생성기를 실행합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [generator-name]"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "플래그-옵션",
      children: "플래그 옵션"
    }), "\n", _jsx(_components.h4, {
      id: "--args",
      children: _jsx(_components.code, {
        children: "--args"
      })
    }), "\n", _jsx(_components.p, {
      children: "생성기의 프롬프트에 직접 전달할 답변입니다."
    }), "\n", _jsx(_components.h4, {
      id: "--config-path",
      children: _jsx(_components.code, {
        children: "--config <path>"
      })
    }), "\n", _jsx(_components.p, {
      children: "생성기 설정 파일입니다."
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "turbo/generators/config.js"
      })]
    }), "\n", _jsx(_components.h4, {
      id: "--root-path",
      children: _jsx(_components.code, {
        children: "--root <path>"
      })
    }), "\n", _jsx(_components.p, {
      children: "저장소의 루트입니다"
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: 루트 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "이 있는 디렉토리"]
    }), "\n", _jsx(_components.h2, {
      id: "workspace",
      children: _jsx(_components.code, {
        children: "workspace"
      })
    }), "\n", _jsx(_components.p, {
      children: "새 workspace를 생성합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " workspace"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [options]"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "플래그-옵션-1",
      children: "플래그 옵션"
    }), "\n", _jsx(_components.h4, {
      id: "--name-name",
      children: _jsx(_components.code, {
        children: "--name <name>"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "package.json"
      }), "의 ", _jsx(_components.code, {
        children: "name"
      }), " 키에 사용될 새 workspace의 이름입니다. ", _jsx(_components.code, {
        children: "name"
      }), " 키는 저장소에서 패키지의 고유 식별자입니다."]
    }), "\n", _jsx(_components.h4, {
      id: "--empty",
      children: _jsx(_components.code, {
        children: "--empty"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["빈 workspace를 생성합니다. 기본값은 ", _jsx(_components.code, {
        children: "true"
      }), "입니다."]
    }), "\n", _jsx(_components.h4, {
      id: "--copy-nameurl",
      children: _jsx(_components.code, {
        children: "--copy <name>/<url>"
      })
    }), "\n", _jsx(_components.p, {
      children: "monorepo 내의 로컬 workspace 이름 또는 모든 브랜치 및/또는 하위 디렉토리가 있는 정규화된 GitHub URL입니다."
    }), "\n", _jsx(_components.h4, {
      id: "--destination-path",
      children: _jsx(_components.code, {
        children: "--destination <path>"
      })
    }), "\n", _jsx(_components.p, {
      children: "새 workspace가 생성될 위치입니다."
    }), "\n", _jsx(_components.h4, {
      id: "--type-apppackage",
      children: _jsx(_components.code, {
        children: "--type <app/package>"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["생성할 workspace의 유형입니다 (", _jsx(_components.code, {
        children: "app"
      }), " 또는 ", _jsx(_components.code, {
        children: "package"
      }), ")."]
    }), "\n", _jsx(_components.h4, {
      id: "--root-path-1",
      children: _jsx(_components.code, {
        children: "--root <path>"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["저장소의 루트입니다. 기본값은 루트 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "의 디렉토리입니다."]
    }), "\n", _jsx(_components.h4, {
      id: "--show-all-dependencies",
      children: _jsx(_components.code, {
        children: "--show-all-dependencies"
      })
    }), "\n", _jsx(_components.p, {
      children: "의존성을 추가할 때 workspace 유형별 의존성 필터링을 방지합니다."
    }), "\n", _jsxs(_components.h4, {
      id: "--example-path-path--p-path",
      children: [_jsx(_components.code, {
        children: "--example-path <path>"
      }), ", ", _jsx(_components.code, {
        children: "-p <path>"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["드문 경우지만, GitHub URL에 슬래시가 있는 브랜치 이름(예: ", _jsx(_components.code, {
        children: "bug/fix-1"
      }), ")과 예제 경로(예: ", _jsx(_components.code, {
        children: "foo/bar"
      }), ")가 포함될 수 있습니다. 이 경우 예제 경로를 별도로 지정해야 합니다."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
